/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Checkbox, VerticalSpace } from '@brokerbay/design-components';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { FeedbackInputProps } from '../types';

type FeedbackCheckboxProps = FeedbackInputProps;

const FeedbackCheckbox: React.FC<FeedbackCheckboxProps> = ({
  onChange,
  disabled,
  template: { options, response = '' },
}) => {
  const responseArr = response.split('  ');

  const checkedOptions = options.map(option => responseArr.includes(option));

  const _onChange = (ev: CheckboxChangeEvent, index: number) => {
    const foundIndex = responseArr.findIndex(el => el === options[index]);

    if (ev.target.checked) {
      if (foundIndex === -1) responseArr.push(options[index]);
    } else if (!ev.target.checked) {
      if (foundIndex === 1) responseArr.splice(foundIndex, 1);
    }

    onChange(responseArr.join('  '));
  };

  return (
    <VerticalSpace size="small">
      {options.map((option, index) => (
        <Checkbox
          disabled={disabled}
          key={option}
          checked={checkedOptions[index]}
          onChange={ev => _onChange(ev, index)}
        >
          {option}
        </Checkbox>
      ))}
    </VerticalSpace>
  );
};

export default FeedbackCheckbox;
